package nl.astraeus.wiki.oauth

expect fun generateRandom(): String

data class OauthClient(
  val clientId: String,
  val clientSecret: String,
  val oauthState: String = generateRandom()
)
